import { render } from "./HeaderLogoComponent.vue?vue&type=template&id=1e62c81c"
import script from "./HeaderLogoComponent.vue?vue&type=script&lang=js"
export * from "./HeaderLogoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__